export const CRYPTO_ASSET_ROUTE_CHAINS = [
  { chainId: "8453", slug: "base" },
  { chainId: "1", slug: "ethereum" },
  { chainId: "42161", slug: "arbitrum" },
  { chainId: "56", slug: "bnb" },
  { chainId: "4663", slug: "robinhood" },
  { chainId: "999", slug: "hyperevm" },
  { chainId: "143", slug: "monad" },
  { chainId: "1399811149", slug: "solana" },
] as const satisfies readonly {
  readonly chainId: string;
  readonly slug: string;
}[];

export type CryptoAssetRouteChain = (typeof CRYPTO_ASSET_ROUTE_CHAINS)[number];

export function resolveCryptoAssetRouteChain(
  value: string | number | null | undefined,
): CryptoAssetRouteChain | null {
  if (value === null || value === undefined) {
    return null;
  }

  const normalized = String(value).trim().toLowerCase();
  if (!normalized) {
    return null;
  }

  return (
    CRYPTO_ASSET_ROUTE_CHAINS.find(
      (chain) => chain.slug === normalized || chain.chainId === normalized,
    ) ?? null
  );
}
